import { useContext } from 'react';
import { UserContext } from '../model/UserContext';





export const useTokenLogin = (): {

    token: string | null;
    login: (token: string, is_system_login: boolean) => Promise<void>;
    logout: () => Promise<void>;
    isAuthorized: boolean;
} => {
    const context = useContext(UserContext);
    if (!context) {
        return {
            token: null,
            login: async () => { },
            logout: async () => { },
            isAuthorized: false,
        };
    }
    return {
        token: context.token,
        login: context.login,
        logout: context.logout,
        isAuthorized: context.isAuthorized,
    };
};
